import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { MappingCell, YesNoCell, NAGuard, CellFunction } from '../../cells';
import Tooltip from '../../../tooltip';
import Icon from '../../../../atoms/icon';
import { IEpxDischargeHT } from '../../../../../libs/apps/epxdischargeht';
import { TriStateLiteral } from '../../../../../libs/session';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { useTerms } from '../../../../../contexts/terms';

/**
 * Return N/A if it's a text-in or one-off session
 */
const GetNACheckRegular = () => {
  return (session: IEpxDischargeHT): boolean => {
    return session.isConnect === true || session.noResponseNeeded === true;
  };
};

/**
 * Return Yes/No if isConnect is true
 * Otherwise, return N/A if noResponseNeeded is true
 */
const GetNACheckConnect = () => {
  return (session: IEpxDischargeHT): boolean => {
    return session.isConnect === false && session.noResponseNeeded === true;
  };
};

const EpxDischargeHTTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const { terms } = useTerms();
  const columns: Column<IEpxDischargeHT>[] = [
    {
      Header: (
        <Tooltip
          content={`This value may be N/A either if the ${terms.patient.default} texted in to the program phone number, or if they received a one-off outreach where no response was needed.`}
        >
          <span>
            Feeling Worse
            <Icon className="ml-2" icon={faInfoCircle} />
          </span>
        </Tooltip>
      ),
      id: 'feeling',
      Cell: NAGuard(
        ResponseGuard(
          MappingCell(
            'feeling',
            TriStateLiteral
          ) as CellFunction<IEpxDischargeHT>
        ),
        GetNACheckRegular()
      )
    },
    {
      Header: (
        <Tooltip
          content={`This value may be N/A if the ${terms.patient.default} received a one-off outreach where no response was needed.`}
        >
          <span>
            Patient Texted In?
            <Icon className="ml-2" icon={faInfoCircle} />
          </span>
        </Tooltip>
      ),
      id: 'isConnect',
      Cell: NAGuard(
        ResponseGuard(YesNoCell('isConnect') as CellFunction<IEpxDischargeHT>),
        GetNACheckConnect()
      )
    }
  ];
  return (
    <SessionTable<IEpxDischargeHT>
      url="/epxdischargeht/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxDischargeHTTable;
